import { useMemo } from 'react'
import { useLocale } from 'react-intlayer'
import type { Locale, LocalePort } from '../domain/locale'

const useIntlayerLocaleAdapter = (): LocalePort => {
	const { locale, setLocale } = useLocale()

	return useMemo(() => ({
		get: () => locale as Locale,
		set: (next: Locale) => setLocale(next),
	}), [locale, setLocale])
}

export { useIntlayerLocaleAdapter }
